<template>
  <v-dialog v-model="dialog" max-width="300">
    <v-card>
      <v-card-title class="headline grey lighten-3 elevation-3" primary-title>Edit track time</v-card-title>
      <v-card-text>
        <v-text-field label="Time" v-model="time.duration"></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'TimesDialog',
    props: ['time'],
    data() {
      return {
        dialog: false
      }
    },
    methods: {
      open(){
        this.dialog = true
      },
      close(){
        this.dialog = false
      },
      save() {
        this.$api.times.save(this.time).then(() => {
          this.close()
          this.$emit('edit')
        })
      }
    }
  }
</script>